import React, { useState, useRef, useEffect, useCallback } from 'react';
import * as Colors from '../../../styles/colors';
import { AsyncTypeahead, Menu, MenuItem, Highlighter } from 'react-bootstrap-typeahead';
import TailOption from '../../tails/lookup/TailOption';
import {
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { buttonBackground } from '../../../styles/colors';
import { OPERATOR_LOOKUP, OPERATORS_LOOKUP } from '../../operators/lookup/queries';
import { useMutation, useLazyQuery } from '@apollo/client';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import ReactDOM from "react-dom";
import './styles.css';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const lookupInputContainer = {
  display: 'inline-flex',
  flex: 1,
  alignItems: 'flex-end'
}

const operatorOptionContainer = {
  // display: 'flex',
  // flex: 1,
  // borderBottom: '1px solid #ccc',
  // marginTop: '0px',
  backgroundColor: '#EFEFEF',
}

const lookupInput = {
  borderRadius: '6px 0px 0px 6px',
  padding: '0px',
  fontSize: '1rem',
  backgroundColor: '#EFEFEF',
  border: 'none',
  width: '100%',
  paddingLeft: '30px',
  color: 'black',
  height: '1.89rem'
}

const newLookupInput = {
  borderRadius: '6px 0px 0px 6px',
  padding: '0px',
  fontSize: '1rem',
  backgroundColor: '#EFEFEF',
  border: 'none',
  width: '250px',
  paddingLeft: '30px',
  color: 'black',
  marginTop: '5px'
  // height: '2.75rem'
}

const Icon = styled(FontAwesomeIcon)`
  margin-right: 12px;
  font-weight: 500;
  color: ${buttonBackground};
`;

const Search = styled.div`
  margin-top: 36px;
  margin-left: -5px;
  z-index: 100;
  border: 0px;
  background-color: ${buttonBackground};
  border-radius: 0px 6px 6px 0px;
  color: white;
  font-size: 1.25rem;
  padding: 12px;
  @media (max-width: 768px) {
    font-size: 1.25;
    padding: 12px;
    white-space: nowrap;
  }
`;

const OperatorLookupInput = (props) => {
  const {
    foundOperator,
    setFoundOperator,
    foundOperatorBackup,
    setFoundOperatorBackup,
    currentInput,
    setCurrentInput,
    setFoundTail
  } = props;
  const foundOperatorName = foundOperator !== '' ? foundOperator.name : '';
  const [selectedOperator, setSelectedOperator] = useState('');
  const [term, setTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [menuOptions, setMenuOptions] = useState([]);
  const [typing, setTyping] = useState(false);
  const operatorLookupInput = useRef(null);
  const [requery, setRequery] = useState(true);
  const hideMenu = () => {
    operatorLookupInput.current.hideMenu();
    operatorLookupInput.current.clear();
  }

  const [
    operatorsLookup,
    { loading, data },
  ] = useLazyQuery(OPERATORS_LOOKUP);

  const handleLookup = (query) => {
    if(query === foundOperator && !requery) {
      setRequery(true)
    }else {
      setRequery(false)
    }
    if(query?.length >=3) {
      setIsLoading(true)
      operatorsLookup({ variables: { term: query }})
    }
  }

  const [
    operatorLookup,
    { loading: operatorLoading, data: operatorData },
  ] = useLazyQuery(OPERATOR_LOOKUP);

  const selected = (option) => {
    // setCurrentInput('')
    let menuOption = menuOptions.find(mOption =>
      mOption.id === option.id
    )

    if(menuOption) {
      setSelectedOperator(menuOption)
      operatorLookup({ variables: { id: menuOption.id } })
      // setCurrentInput('operator')
      // setFoundTail('')
    }
  }

  useEffect(() => {
    if (data && data.operatorsLookup && isLoading) {
      if(menuOptions !== data.operatorsLookup) {
        setIsLoading(false)
        setMenuOptions([])
        let mOptions = data.operatorsLookup
        setMenuOptions(mOptions)
      }
    }
  }, [data, loading]);

  useEffect(() => {
    if (operatorData && operatorData.operatorLookup) {
      setFoundOperator(operatorData.operatorLookup)
      setCurrentInput('operator')
      setIsLoading(false)
    }
  }, [operatorData, operatorLoading]);

  const filterBy = () => true;

  const getEmptyResults = () => {
    return <span style={{fontWeight: 'bold', color: 'red'}}>No Operators Found</span>
  }

  return (
    <div className="lookup-input-container" style={lookupInputContainer}>

      {/*<AsyncTypeahead
        id="lookup-input"
        filterBy={filterBy}
        isLoading={isLoading}
        labelKey={option => `${option.tailNumber}`}
        size='large'
        useCache={false}
        onSearch={query => {
          setTerm(query)
          handleLookup(query)
        }}
        // onInputChange={query => setTerm(query)}
        onFocus={(event) => {
          if(requery) {
            handleLookup(event.target.value)
          }
        }}
        options={menuOptions}
        emptyLabel={getEmptyResults()}
        defaultInputValue={foundTailNumber}
        renderMenuItemChildren={(option, props, idx) => {
          return (
            <TailOption option={option} selected={selected}/>
          )
        }}
        inputProps={{
          style: lookupInput
        }}
      />*/}
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={menuOptions.map(option => {
          return {label: option.name, id: option.id}
        })}
        getOptionLabel={option => {
          return option['name']
        }}
        sx={newLookupInput}
        onInputChange={event => handleLookup(event?.target?.value)}
        filterOptions={(x) => x}
        onChange={(event, newValue) => selected(newValue)}
        noOptionsText={getEmptyResults()}
        onFocus={(event) => {
          // if(requery) {
            // handleLookup(event.target.value)
          // }
        }}
        // defaultValue={foundOperatorName}
        renderInput={(params) => {
          return <TextField {...params} label="Operator Name" variant="outlined" />
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.label}
            </li>
          )
        }}
      />
      <Search>
        <Icon icon={faMagnifyingGlass} style={{color: 'white'}}/>
        Operator Name
      </Search>
    </div>
  )
}

export default OperatorLookupInput;
